
import { useEffect } from "react";
import { useUiStore } from "../stores/uiStore";
import type { EditMode } from "../stores/types";
import { useSpacePermissions } from "./useSpacePermissions";

export interface UseEditModeReturn {
  editMode: EditMode;
  isReadonly: boolean;
  isEditing: boolean;
  canEdit: boolean;
  enterEditMode: () => void;
  exitEditMode: () => void;
  toggleEditMode: () => void;
}

export function useEditMode(): UseEditModeReturn {
  const { canEdit } = useSpacePermissions();
  const editMode = useUiStore((s) => s.editMode);
  const enterEditMode = useUiStore((s) => s.enterEditMode);
  const exitEditMode = useUiStore((s) => s.exitEditMode);
  const toggleEditMode = useUiStore((s) => s.toggleEditMode);

  // Drop out of editing if permission is lost (logout, space change, auth resolved).
  useEffect(() => {
    if (!canEdit && editMode === "editing") {
      exitEditMode();
    }
  }, [canEdit, editMode, exitEditMode]);

  return {
    editMode,
    canEdit,
    isReadonly: !canEdit || editMode === "readonly",
    isEditing: canEdit && editMode === "editing",
    enterEditMode: () => {
      if (canEdit) enterEditMode();
    },
    exitEditMode,
    toggleEditMode: () => {
      if (canEdit) toggleEditMode();
    },
  };
}
